package org.vreo.devicehub.features.settings.presentation.settings

/**
 * Settings ui actions
 */
sealed interface SettingsActions {
    data object OnClearError : SettingsActions
        data object OnGetDeviceConfigClicked : SettingsActions
    data object OnSaveClicked : SettingsActions
    data class OnZoomPositionChanged(val value: String) : SettingsActions
    data class OnFocusPositionChanged(val value: String) : SettingsActions
    data object OnSingleShotAutofocusClicked : SettingsActions
    data class OnFrameRotationSelected(val index: Int) : SettingsActions
    data class OnBrightnessChanged(val value: String) : SettingsActions
    data class OnExposureTimeChanged(val value: String, val isMax: Boolean) : SettingsActions
    data class OnGainChanged(val value: String, val isMax: Boolean) : SettingsActions
    data class OnUpdateReleaseTypeSelected(val index: Int) : SettingsActions
}